import { render } from "./MLoading.vue?vue&type=template&id=923b9f30&scoped=true"
const script = {}

import "./MLoading.vue?vue&type=style&index=0&id=923b9f30&scoped=true&lang=css"

import exportComponent from "D:\\NVManh\\Github\\MS.eShop\\eShopV2\\web-thaisalon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-923b9f30"]])

export default __exports__